import React from 'react';
import proptypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { checkPricingExistence } from '../../../super-sku-util';

const { string, number, shape, bool } = proptypes;

export const CardPrice = ({ pricing }) => {

  const { isSpecialPrice, message, price, strikeThroughPriceForMap } = pricing || {};
  const { cents, dollars, formatted, lessThanDollar } = price || {};

  if (!checkPricingExistence(pricing)) {
    return null;
  }

  const specialPrice = isSpecialPrice && 'success';

  return message
    ? (
      <div className="sui-flex sui-justify-center">
        <Typography
          decoration={strikeThroughPriceForMap && 'line-through'}
          variant="body-sm"
        >
          {strikeThroughPriceForMap && formatted}
        </Typography>
        <Typography variant="body-xs">See Price in Cart</Typography>
      </div>
    ) : (
      <div className="sui-flex sui-justify-center">
        {lessThanDollar
          ? (
            <Typography variant="body-sm" component="span" weight="bold" color={specialPrice}>{cents}¢</Typography>
          )
          : (
            <>
              <Typography variant="body-sm" component="span" weight="bold" color={specialPrice}>${dollars}</Typography>
              <Typography variant="body-sm" component="span" weight="bold" color={specialPrice}>{cents}</Typography>
            </>
          )}
      </div>
    );
};

CardPrice.displayName = 'Card Price';

CardPrice.propTypes = {
  pricing: shape({
    isSpecialPrice: bool,
    message: bool,
    price: shape({
      cents: number,
      dollars: number,
      formatted: string,
      lessThanDollar: bool,

    }),
    strikeThroughPriceForMap: bool,
  }).isRequired,
};
